import type { ResponseItem } from '@app/src/types/resourceExplorer'
import { reporting } from '@app/src/wf-constants/paths'
import qs from 'qs'
import { useHistory } from 'react-router-dom'

const useNavigateToQuestionnaire = () => {
  const history = useHistory()

  return (item: ResponseItem | undefined) => {
    if (item?.response?.request?.id && item?.responseId) {
      history.push({
        pathname: reporting,
        search: qs.stringify({
          requestId: item.response.request.id,
          responseId: item.responseId,
        }),
      })
    }
  }
}

export default useNavigateToQuestionnaire
